<autocomplete-list-item (clicked)="triggerEvent()"> {{ itemName(item) }} </autocomplete-list-item>
